import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { doc } from "firebase/firestore";
import { useUser } from "reactfire";
import { classNames } from "utils/utils";
import { IonButton, IonCard, IonCardContent } from "@ionic/react";
import { useFirestore, useFirestoreDocData } from "reactfire";
import ErrorBoundary from "components/errorBoundary";

import CardHeader from "./header";
import CardContent from "./content";
import CardFooter from "./footer";
import { useGame } from "context/gameContext";
import SkeletonLoader, { EmptyTournamentCard } from "components/skeletonLoader";
import { Md2Lock } from "react-icons-ng/md2";

export default function LeagueCard({ leagueData, invited, messageId, slim }) {
  const { settled } = leagueData;

  const [userRoundData, setUserRoundData] = useState(undefined);

  const firestore = useFirestore();
  const { t } = useTranslation();
  const { status, data: user } = useUser();

  const {
    state: { premium, leagues, gameList },
  } = useGame();

  const seasonRef = leagues?.find(
    (league) => league.id === leagueData?.leagueRef
  );

  const gameRef = gameList?.find((game) => game.id === leagueData?.gameTypeId);
  const leagueLocked = (seasonRef?.premium || gameRef?.premium) && !premium;

  const userRoundDataRef = doc(
    firestore,
    "userTournaments/" + leagueData?.id + "/users/",
    user?.uid
  );
  const { status: userRoundDataStatus, data: userRoundDataDoc } =
    useFirestoreDocData(userRoundDataRef);
  useEffect(() => {
    if (userRoundDataDoc) {
      setUserRoundData(userRoundDataDoc);
    }
  }, [userRoundDataDoc]);

  return userRoundDataStatus !== "success" ? (
    <EmptyTournamentCard variant={"large"} />
  ) : (
    <ErrorBoundary>
      <IonCard
        mode="ios"
        className={classNames(
          "p-0 m-0 w-full",
          slim ? "h-32" : invited ? "h-24" : "h-48",
          settled || userRoundData?.gameOver ? "shadow-none" : "shadow-md"
        )}
      >
        <IonCardContent
          className={classNames(
            "p-0",
            settled || userRoundData?.gameOver ? "bg-white" : "bg-black"
          )}
        >
          <div className="flex h-fit rounded-t-md relative">
            <img
              src={leagueData?.leagueImage}
              className={classNames(
                "w-full object-cover rounded-t-md",
                slim ? "h-32" : invited ? "h-24" : "h-48",
                (settled || userRoundData?.gameOver) && "grayscale opacity-50"
              )}
              alt="Logo"
            />

            <div className="absolute flex flex-col w-full h-full justify-between bg-gradient-to-b from-transparent via-black/20 to-black/80">
              <CardHeader leagueData={leagueData} />
              {!invited && !slim && (
                <CardContent
                  leagueData={leagueData}
                  userRoundData={userRoundData}
                  invited={invited}
                />
              )}
              <div className="flex items-center justify-center space-x-2">
                {slim && (
                  <div className="flex items-center justify-center">
                    <div className="flex font-ultralight text-xs text-black bg-white/80 w-fit p-2 py-1 rounded-md">
                      {leagueData?.userCount}{" "}
                      {t("lobby.card.players", {
                        count: leagueData?.userCount,
                      })}
                    </div>
                  </div>
                )}

                {leagueLocked && !userRoundData && !invited && (
                  <div className="flex items-center justify-center">
                    <div className="flex font-ultralight text-xs text-black bg-white/80 w-fit p-2 py-1 rounded-md">
                      <Md2Lock className="h-4 w-4 mr-1 text-black" />
                      Premium
                    </div>
                  </div>
                )}
              </div>
              <CardFooter
                leagueData={leagueData}
                userRoundData={userRoundData}
                invited={invited}
                messageId={messageId}
              />
            </div>
          </div>
        </IonCardContent>
      </IonCard>
    </ErrorBoundary>
  );
}
